import { render, staticRenderFns } from "./SchoolAwayDetailPage.vue?vue&type=template&id=00e82c58&scoped=true&"
import script from "./SchoolAwayDetailPage.vue?vue&type=script&lang=js&"
export * from "./SchoolAwayDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e82c58",
  null
  
)

export default component.exports